import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Root, ButtonWrapper, Button } from './styles';
import IconSVG from '../../Icon/IconSVG';

class Zoom extends PureComponent {
  handleZoomIn = () => {
    this.props.onZoomClick(0.5);
  };

  handleZoomOut = () => {
    this.props.onZoomClick(-0.5);
  };

  render() {
    const { readOnly } = this.props;

    return (
      <Root readOnly={readOnly}>
        <ButtonWrapper>
          <Button onClick={this.handleZoomIn}>
            <IconSVG name="plus" color="white" />
          </Button>
          <Button onClick={this.handleZoomOut}>
            <IconSVG name="minus" color="white" />
          </Button>
        </ButtonWrapper>
      </Root>
    );
  }
}

Zoom.propTypes = {
  readOnly: PropTypes.bool,
  onZoomClick: PropTypes.func
};

export default Zoom;
